import React, { useState } from 'react';
import ProjectCard from "./ProjectCard";
import { useNavigate } from "react-router-dom";
import { project_list as projects } from "./project_list";
import Tabs from "../../components/RetroForms/Tabs";
import "./Portfolio.css"


const title =
    " ______  ______  ______  ______  ______  ______  __      __  ______   \n" +
    "/\\  == \\/\\  __ \\/\\  == \\/\\__  _\\/\\  ___\\/\\  __ \\/\\ \\    /\\ \\/\\  __ \\  \n" +
    "\\ \\  _-/\\ \\ \\/\\ \\ \\  __<\\/_/\\ \\/\\ \\  __\\\\ \\ \\/\\ \\ \\ \\___\\ \\ \\ \\ \\/\\ \\ \n" +
    " \\ \\_\\   \\ \\_____\\ \\_\\ \\_\\ \\ \\_\\ \\ \\_\\   \\ \\_____\\ \\_____\\ \\_\\ \\_____\\\n" +
    "  \\/_/    \\/_____/\\/_/ /_/  \\/_/  \\/_/    \\/_____/\\/_____/\\/_/\\/_____/"
const Portfolio: React.FC = () => {
    const [selectedTag, setSelectedTag] = useState("All");
    const navigate = useNavigate()
    const filteredProjects = selectedTag === "All"
        ? projects
        : selectedTag === "Mobile"
            ? projects.filter((project) =>
                project.technologies.includes("React Native" || "Android" || "Swift"))
            : projects.filter((project) => project.technologies.includes(selectedTag));

    function handleClick(id: number) {
        window.scrollTo(0, 0)
        return navigate(`/project/${id}`)

    }

    return (
        <div>
            <pre className={"ascii-title"}>
                {title}
            </pre>

            {window.innerWidth > 700 && <Tabs tabs={["All", "Mobile", "Typescript", "Python", "React", "Django", "Java"]} onSelectTab={setSelectedTag}></Tabs>}

            <div className={"project-card-container"}>

                {filteredProjects.map((project, id) => {
                    return <ProjectCard project={project} key={id} onClick={() => handleClick(project.id)}></ProjectCard>
                })}
            </div>


        </div>
    );
}
    ;

export default Portfolio;
